import { TextField } from "@mui/material";
import { Col } from "react-bootstrap";

export default function PasswordFields({
  values,
  handleChange,
  errors,
  touched,
}) {
  return (
    <>
      <Col xs={12} md={6}>
        <TextField
          fullWidth
          label="Hasło"
          type="password"
          name="password"
          margin="normal"
          value={values.password}
          onChange={handleChange}
          error={touched.password && Boolean(errors.password)}
          helperText={touched.password && errors.password}
        />
      </Col>
      <Col xs={12} md={6}>
        <TextField
          fullWidth
          label="Powtórz hasło"
          type="password"
          name="passwordrepeat"
          margin="normal"
          value={values.passwordrepeat}
          onChange={handleChange}
          error={touched.passwordrepeat && Boolean(errors.passwordrepeat)}
          helperText={touched.passwordrepeat && errors.passwordrepeat}
        />
      </Col>
    </>
  );
}
